import { Locale, localeIndexOfLowercase } from '@ardoq/locale';

export type MatchGroups = {
  preMatch: string;
  match: string;
  postMatch: string;
};

export const escapeRegExp = (value: string) =>
  /[-[\]{}()*+!<=:?.\\^$|,]/g.test(value)
    ? value.replace(/[-[\]{}()*+!<=:?.\\^$|,]/g, '\\$&')
    : value;

export const findMatchGroups = (
  value: string,
  searchPhrase: string,
  locale: Locale
): MatchGroups => {
  const index = localeIndexOfLowercase(value, searchPhrase, locale);
  const lastIndex = index + searchPhrase.length;

  if (index === -1) return { preMatch: value, match: '', postMatch: '' };

  return {
    preMatch: value.slice(0, index),
    match: value.slice(index, lastIndex),
    postMatch: value.slice(lastIndex),
  };
};
